import { render, staticRenderFns } from "./OmniSearchResults.vue?vue&type=template&id=19ada9d2&scoped=true&"
import script from "./OmniSearchResults.vue?vue&type=script&lang=js&"
export * from "./OmniSearchResults.vue?vue&type=script&lang=js&"
import style0 from "./OmniSearchResults.vue?vue&type=style&index=0&id=19ada9d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ada9d2",
  null
  
)

export default component.exports